import React, { useEffect } from 'react';
import './ActionModal.css';

export default function ActionModal({ open, onClose, logLines }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEsc);

    if (open) {
      document.body.style.overflow = 'hidden';
      document.body.style.pointerEvents = 'none';
    } else {
      document.body.style.overflow = '';
      document.body.style.pointerEvents = '';
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
      document.body.style.pointerEvents = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('action-overlay')) {
      onClose();
    }
  };

  return (
    <div className="action-overlay" onClick={handleOverlayClick}>
      <div className="action-panel" onClick={(e) => e.stopPropagation()}>
        <h2>Transaction Result</h2>
        <ul>
          {logLines.flatMap((line, index) => {
            // Reward + Bonus varsa parçala
            if (/Reward:/i.test(line) && /Bonus:/i.test(line)) {
              const parts = line.split(/(Reward: .*?RANCH|Bonus: .*?RANCH)/).filter(Boolean);
              return parts.map((part, idx) => <li key={`${index}-${idx}`}>{part.trim()}</li>);
            }

            // Diğer loglar
            return <li key={index}>{line}</li>;
          })}
        </ul>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
